export default __webpack_public_path__ + "static/media/lightbulb.adecdf03.svg";